import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { SiLandingPageComponent } from '@siemens/element-ng/landing-page';
import { Link } from '@siemens/element-ng/link';
import { ModalRef, SiModalService } from '@siemens/element-ng/modal';

import { IFRAME_THEME_CSS } from '../main/about/about-iframe-theme';

import { SettingsService } from '../../services/settings.service';
import { AuthService } from '../../services/auth.service';

const MODAL_OPTIONS = { class: 'modal-xl', ignoreBackdropClick: false } as const;

@Component({
  selector: 'app-landing',
  imports: [SiLandingPageComponent, TranslateModule],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent {
  private readonly settingsService = inject(SettingsService);
  private readonly authService = inject(AuthService);
  private readonly modalService = inject(SiModalService);
  private readonly sanitizer = inject(DomSanitizer);

  @ViewChild('legalTpl') legalTpl!: TemplateRef<any>;

  private modalRef?: ModalRef;

  protected readonly availableLanguages = this.settingsService.availableLanguages;
  readonly corporateInformationUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    'assets/corporateInformation.html'
  );
  readonly privacyPolicyUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    'assets/privacyPolicy.html'
  );
  readonly termsOfUseUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    'assets/termsOfUse.html'
  );

  legalModalTitle = '';
  legalModalUrl: SafeResourceUrl = this.termsOfUseUrl;

  readonly links: Link[] = [
    {
      title: 'Corporate information',
      action: () => this.openLegalModal('Corporate Information', this.corporateInformationUrl)
    },
    {
      title: 'Privacy policy',
      action: () => this.openLegalModal('Privacy Policy', this.privacyPolicyUrl)
    },
    {
      title: 'Terms of use',
      action: () => this.openLegalModal('Terms of Use', this.termsOfUseUrl)
    }
  ];

  async onLogin(): Promise<void> {
    await this.authService.login();
  }

  protected openLegalModal(title: string, url: SafeResourceUrl): void {
    this.legalModalTitle = title;
    this.legalModalUrl = url;
    this.modalRef = this.modalService.show(this.legalTpl, MODAL_OPTIONS);
  }

  protected closeLegalModal(): void {
    this.modalRef?.hide();
  }

  protected onIframeLoad(iframe: HTMLIFrameElement): void {
    const iframeDoc = iframe.contentDocument;
    if (!iframeDoc) return;
    const style = iframeDoc.createElement('style');
    style.textContent = IFRAME_THEME_CSS;
    iframeDoc.head.appendChild(style);
  }
}
